<template>
  <Component
    :is="hero?.type?.replace(/_/g, '-')"
    v-for="hero in heros"
    :key="hero.type"
    :data="hero"
    :parent-page="parentPage"
  />
</template>

<script setup>
defineProps({
  parentPage: { type: Object, default: null },
  heros: { type: Array, default: () => [] },
})
</script>
